module.exports = __webpack_public_path__ + "static/img/icon5.77d5f0be.svg";